// src/auth.js
export const getToken = () => localStorage.getItem("token");

export const setToken = (token) => localStorage.setItem("token", token);

export const removeToken = () => localStorage.removeItem("token");

/**
 * Умный wrapper для fetch: автоматически добавляет Authorization заголовок,
 * и НЕ устанавливает Content-Type если body — FormData (для upload'ов).
 */
export async function authFetch(url, options = {}) {
  const token = getToken();
  const headers = { ...(options.headers || {}) };

  // Не устанавливать Content-Type для FormData
  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = headers["Content-Type"] || "application/json";
  }
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(url, { ...options, headers });
  // если 401 — перенаправляем пользователя на логин (или пробрасываем)
  if (res.status === 401 || res.status === 403) {
    // опционально: очистить токен и сделать redirect
    removeToken();
  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
    return Promise.reject(new Error("Unauthorized"));
  }
  return res;
}

export const isAuthenticated = () => {
  const token = getToken();
  return !!token;
};
